import { useQuery } from '@tanstack/react-query';
import { customInstance } from '@/common/infrastructure/http/apiClient';
import { toDocumentType } from '@/document-types/application/mappers/documentTypeMapper';
import type { DocumentType } from '@/document-types/domain/types/DocumentType';

export const documentTypesQueryKey = ['document-builder', 'document-types'] as const;

export const useListDocumentTypes = (): { data: DocumentType[] | undefined; isLoading: boolean; error: unknown } =>
  useQuery({
    queryKey: documentTypesQueryKey,
    queryFn: async () => {
      const response = await customInstance<unknown>({
        url: '/api/pdf-templates/v1/document-types',
        method: 'GET'
      });

      const dtos: unknown[] = Array.isArray(response) ? response : ((response as { items?: unknown[] } | null)?.items ?? []);

      return dtos.map(toDocumentType);
    },
    staleTime: 1000 * 60 * 10
  });

// TODO(rdb-part-06): switch to generated hook once Orval ships useListDocumentTypes
